import PropTypes from 'prop-types';
import React from 'react';
import AttendeeCard from './attendeeCard';

import { Grid } from 'semantic-ui-react';

export default class AttendeesCardManager extends React.Component {
    componentDidMount() {
        this.props.addScrollListener();
    }

    componentWillUnmount() {
        this.props.removeScrollListener();
    }
    /**
     * Render a single attendee card
     */
    renderAttendeeCard(attendee, index) {
        if (!attendee) {
            return null;
        }

        let selected = !!this.props.selectedAttendees.find(sattendee => sattendee.id === attendee.id);

        return (
            <AttendeeCard
                attendee={attendee}
                index={index}
                isChecked={selected}
                onClick={this.props.onAttendeeClick}
                onSelected={this.props.onAttendeeSelected}
                changeSearch={this.props.changeSearch}
                rates={this.props.rates}
            />
        );
    }

    /**
     * Render attendees card columns
     */
    renderAttendeesCards() {
        let { attendees } = this.props;

        let rows = [];

        // render attendees 2 by 2
        for (let i = 0; i < attendees.length; i = i + 2) {
            rows.push(
                <Grid.Row key={i}>
                    <Grid.Column>{this.renderAttendeeCard(attendees[i], i)}</Grid.Column>
                    <Grid.Column>{this.renderAttendeeCard(attendees[i + 1], i + 1)}</Grid.Column>
                </Grid.Row>
            );
        }

        return rows;
    }

    render() {
        return (
            <Grid stackable columns={2}>
                {this.renderAttendeesCards()}
            </Grid>
        );
    }
}

AttendeesCardManager.defaultProps = {
    rates: []
};

AttendeesCardManager.propTypes = {
    addScrollListener: PropTypes.func.isRequired,
    attendees: PropTypes.array.isRequired,
    changeSearch: PropTypes.func.isRequired,
    onAttendeeClick: PropTypes.func.isRequired,
    onAttendeeSelected: PropTypes.func.isRequired,
    removeScrollListener: PropTypes.func.isRequired,
    selectedAttendees: PropTypes.array.isRequired,
    rates: PropTypes.array
};
